import React from "react";

function Test() {
  return (
    <div className="container mt-5 text-white">
      <h2 className="text-center mb-4">
        Development <span>Team</span>
      </h2>

      <div class="card">
        <div class="card-header ">Ateka Sultana</div>
        <div className="card-body text-white">
          <p className="card-text">Phone: +880-1564093894</p>
          <p className="card-text">Address: Noakhali</p>
          <p className="card-text">ID: 19701055</p>
          <p className="card-text">University of Chittagong</p>
        </div>
      </div>

      <div class="card mt-4">
        <div class="card-header ">Samiha Akter</div>
        <div className="card-body text-white">
          <p className="card-text">Phone: +880-16849493894</p>
          <p className="card-text">Address: Noakhali</p>
          <p className="card-text">ID: 19701015</p>
          <p className="card-text">University of Chittagong</p>
        </div>
      </div>
    </div>
  );
}

export default Test;
